import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpFunctionsService } from '../http-services/http-functions.service';

@Injectable({
    providedIn: 'root'
})
export class CreditService {
    // BehaviorSubject to share credit balance across components
    private creditBalanceSubject = new BehaviorSubject<number | null>(null);
    public creditBalance$ = this.creditBalanceSubject.asObservable();

    constructor(private httpService: HttpFunctionsService) { }

    /**
     * Fetch current credit balance from API
     * No caching - just fetches and updates the BehaviorSubject
     * @returns Observable of credit balance
     */
    getCreditBalance(): Observable<number> {
        return this.httpService.getMethod('credit/balance').pipe(
            map((response: any) => response?.data?.balance || 0),
            tap(balance => {
                this.creditBalanceSubject.next(balance);
            }),
            catchError(error => {
                console.error('Failed to fetch credit balance:', error);
                // Return 0 on error, don't update subject
                return of(0);
            })
        );
    }

    /**
     * Get current credit balance from BehaviorSubject (synchronous)
     * @returns Current balance or null if not yet loaded
     */
    getCurrentBalance(): number | null {
        return this.creditBalanceSubject.value;
    }
}
